import React, { useRef, useEffect, useState } from 'react';
import { useFormikContext } from 'formik';
import PopUp from '../../../common/components/PopUp/PopUp';
import LoanDetails from './LoanDetails';
import LoanDetailsCard from './LoanDetailsCard';
import LoanDetailsView from './LoanDetailsView';
import { addObligation, updateObligation } from '../../../common/constants/api';
import { getApplicantionInfo } from '../../../common/utils/applicantionInfo';

const AddLoan = () => {
  const {
    values,
    data,
    setData,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    name,
    setFileUploadErrors,
    fileUploadErrors,
    setFieldTouched,
    handleSubmit,
    isSubmitting,
    resetForm
  } = useFormikContext();
  const [noOfUploadeneeded, setNoOfUploads] = useState('');
  const [steps, setSteps] = useState('showSavedLoanView');
  const [dataView, setDataView] = useState([]);
  const [show, setShow] = useState(false);
  const [popUpType, setPopUpType] = useState('loading');
  const [popUpText, setPopUpText] = useState('init');
  const [indexVal, setIndexVal] = useState(1);
  const [leadId, SetLeadId] = useState(getApplicantionInfo().leadId);
  const [applicantId, setApplicantId] = useState(
    getApplicantionInfo().leadApplicantId
  );
  const [getSavedData, setTogetdata] = useState([]);
  const [getSavedlinks, setSavedLinks] = useState([]);
  const [sactionDocId, setSactionDocId] = useState(null);
  const [statmentDocId, setStatementDocId] = useState(null);
  const [updateAPI, setUpdateAPI] = useState(false);
  const [loanId, setLoanId] = useState(null);
  const [getShowButton, setGetShowButton] = useState(false);
  const saveLoanDetails = async () => {
    let body = {
      lender: values.lender,
      loanType: values.loanType.value,
      sanctionAmount: values.sanctionAmount,
      balanceAmount: values.balanceAmount,
      currentEmi: values.currentEmi,
      totalTenure: values.totalTenure,
      balanceTenure: values.balanceTenure,
      sanctionDocId: sactionDocId,
      statementDocId: statmentDocId
    };
    let applicant = getApplicantionInfo();
    if (!updateAPI) {
      addObligation(applicant.leadId, applicant.leadApplicantId, body)
        .then(async () => {
          await setSteps('showSavedLoanView');
        })
        .catch(error => {
          if (error.response) {
            setShow(false);
          }
        });
    } else {
      updateObligation(
        applicant.leadId,
        applicant.leadApplicantId,
        body,
        loanId
      )
        .then(async () => {
          await setSteps('showSavedLoanView');
        })
        .catch(error => {
          if (error.response) {
            setShow(false);
          }
        });
    }
  };
  useEffect(() => {
    if (values.viewAccount()) {
      setSteps('showSavedLoanView');
    }
  }, []);
  return (
    <div className="w-full  mr-auto  block px-5 py-4 bg-white ">
      {steps == 'showLoanDetails' ? (
        <React.Fragment>
          <div className="w-full py-3 my-1">
            <LoanDetails
              values={values}
              data={data}
              setData={setData}
              handleChange={handleChange}
              errors={errors}
              touched={touched}
              handleBlur={handleBlur}
              setFieldError={setFieldError}
              setFieldValue={setFieldValue}
              name={name}
              setFileUploadErrors={setFileUploadErrors}
              fileUploadErrors={fileUploadErrors}
              setFieldTouched={setFieldTouched}
              handleSubmit={handleSubmit}
              isSubmitting={isSubmitting}
              setSteps={setSteps}
              setPopUpType={setPopUpType}
              setPopUpText={setPopUpText}
              setShow={setShow}
              getSavedData={getSavedData}
              setTogetdata={setTogetdata}
              setSactionDocId={setSactionDocId}
              setStatementDocId={setStatementDocId}
              resetForm={resetForm}
              setUpdateAPI={setUpdateAPI}
              setLoanId={setLoanId}
            />
            {isSubmitting ||
            values.lenderName == '' ||
            errors.lenderName ||
            errors.loanType ||
            values.loanType == '' ||
            values.sanctionAmount == '' ||
            errors.sanctionAmount ||
            errors.balanceAmount ||
            values.balanceAmount == '' ||
            values.totalTenure == '' ||
            errors.totalTenure ||
            errors.balanceTenure ||
            values.balanceTenure == '' ? null : (
              <PageButton setSteps={setSteps} onclik={saveLoanDetails} />
            )}
          </div>
        </React.Fragment>
      ) : null}
      {steps == 'showSavedLoanView' ? (
        <React.Fragment>
          <LoanDetailsCard
            setSteps={setSteps}
            setDataView={setDataView}
            setShow={setShow}
            setIndexVal={setIndexVal}
            setPopUpType={setPopUpType}
            setPopUpText={setPopUpText}
            setGetShowButton={setGetShowButton}
          />
          {getShowButton ? (
            <div className="w-full clear-both py-4">
              <button
                type="button"
                className="submitButton font-roboto text-white text-base w-48 my-0 "
                onClick={async () => {
                  await setFieldValue('addNewLoan', false);
                  handleSubmit();
                }}
              >
                NEXT
              </button>
            </div>
          ) : null}
        </React.Fragment>
      ) : null}
      {steps == 'showLoanDetailsView' ? (
        <React.Fragment>
          <LoanDetailsView
            setSteps={setSteps}
            setDataView={setDataView}
            data={dataView}
            setShow={setShow}
            indexVal={indexVal}
            setIndexVal={setIndexVal}
            setPopUpType={setPopUpType}
            setPopUpText={setPopUpText}
            setTogetdata={setTogetdata}
          />{' '}
          <div className="w-full clear-both py-4">
            <button
              type="button"
              className="submitButton font-roboto text-white text-base w-48 my-0 "
              onClick={async () => {
                await setFieldValue('addNewLoan', false);
                handleSubmit();
              }}
            >
              NEXT
            </button>
          </div>
        </React.Fragment>
      ) : null}
      <PopUp type={popUpType} text={popUpText} setShow={setShow} show={show} />
    </div>
  );
};
const PageButton = props => {
  const { setSteps, onclik } = props;
  const onCancelClick = () => {
    setSteps('showSavedLoanView');
  };
  return (
    <div
      className="w-full flex items-center h-20 mx-auto"
      style={{ width: 'fit-content' }}
    >
      <button
        type="button"
        className="bg-white border border-black-500 font-roboto text-black-500  py-2  rounded  text-base w-48 mt-8"
        onClick={onCancelClick}
      >
        Cancel
      </button>
      <button
        type="button"
        className="submitButton font-roboto text-white text-base w-48 my-0 "
        style={{ marginLeft: '10px', marginRight: '10px' }}
        onClick={() => {
          onclik();
        }}
      >
        Add
      </button>
    </div>
  );
};

export default AddLoan;
